import { Country, Currency } from '../models';

// TODO refactor into selectCurrency()
export const findCountryCurrency = (country: Country | undefined, currencies: Currency[] | undefined) =>
  (currencies ?? []).find(({ currencyId }) => currencyId === country?.defaultCurrency?.currencyId);
